import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksServices(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_SERVICES,
		dtConfig[ModulesMap.DONE_WORKS_SERVICES].getDoneWorksServices,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorksServicePreview(companyId, doneWorkId, serviceId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_SERVICES,
		dtConfig[ModulesMap.DONE_WORKS_SERVICES].getDoneWorksServicePreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				serviceId,
			},
		},
	)
}
function getDoneWorksServicePopup(companyId, doneWorkId, serviceId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_SERVICES,
		dtConfig[ModulesMap.DONE_WORKS_SERVICES].getDoneWorksServicePopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				serviceId,
			},
		},
	)
}

function createDoneWorksService(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_SERVICES,dtConfig[ModulesMap.DONE_WORKS_SERVICES].createDoneWorksService, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function getDoneWorksService(companyId, doneWorkId, serviceId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_SERVICES,dtConfig[ModulesMap.DONE_WORKS_SERVICES].getDoneWorksService, {
		urlParams: {
			companyId,
			doneWorkId,
			serviceId,
		},
	})
}

function patchDoneWorksService(companyId, doneWorkId, serviceId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_SERVICES,dtConfig[ModulesMap.DONE_WORKS_SERVICES].patchDoneWorksService, {
		urlParams: {
			companyId,
			doneWorkId,
			serviceId,
		},
		...data,
	})
}

function putDoneWorksService(companyId, doneWorkId, serviceId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_SERVICES,dtConfig[ModulesMap.DONE_WORKS_SERVICES].putDoneWorksService, {
		urlParams: {
			companyId,
			doneWorkId,
			serviceId,
		},
		...data,
	})
}

function deleteDoneWorksService(companyId, doneWorkId, serviceId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_SERVICES,dtConfig[ModulesMap.DONE_WORKS_SERVICES].deleteDoneWorksService, {
		urlParams: {
			companyId,
			doneWorkId,
			serviceId,
		},
	})
}

export default {
	getDoneWorksServices,
	getDoneWorksServicePopup,
	getDoneWorksServicePreview,
	getDoneWorksService,
	patchDoneWorksService,
	putDoneWorksService,
	createDoneWorksService,
	deleteDoneWorksService,
}
